import React from "react";

function Footer() {
  return (
    <footer className="footer-wrapper">
      <section className="purchase">
        <div className="container-fluid">
          <div className="wrapper">
            <img src={require("../assets/images/Ikigai.png")} alt="ikigai" className="_book" />
            <div className="_content">
              <h4 className="_heading">Your journey to feeling alive begins here</h4>
            </div>
            <div className="_cta">
              <a href="https://www.penguin.sg/book/this-is-ikigai365" target="_blank" rel="noopener noreferrer" className="btn">
                <span className="material-icons-outlined">
                  store
                </span>BUY NOW</a>
              <p className="text">Also available on</p>
              <img src={require("../assets/images/goodreads-logo.png")} alt="goodreads-logo" className="g-logo" />
            </div>
          </div>
        </div>
      </section>
      <div className="footer pl_15 pr_15">
        <div className="container-fluid">
          <ul className="_socials">
            <li><a href="https://www.instagram.com/ikigai.365/" target="_blank" rel="noopener noreferrer"><img src={require("../assets/images/icons/instagram.png")} width="15" alt="instagram" /></a></li>
            {/* <li><a href="/home"><img src={require("../assets/images/icons/social.png")} width="15" alt="social" /></a></li>
            <li><a href="/home"><img src={require("../assets/images/icons/goodreads.png")} width="15" alt="goodreads" /></a></li> */}
          </ul>
          <div className="copyright-txt">
            <p className="mb-0">Copyright @ 2025 Ikigai 365. All rights reserved</p>
          </div>
          <div className="terms">
            <p className="mb-0"><a href="/privacy-policy">Privacy Policy</a></p>
            <p className="mb-0"><a href="/terms-and-condition">Terms & Conditions</a></p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
